import { render, staticRenderFns } from "./TaskbarIcon.vue?vue&type=template&id=6cc71a97&scoped=true"
import script from "./TaskbarIcon.vue?vue&type=script&lang=js"
export * from "./TaskbarIcon.vue?vue&type=script&lang=js"
import style0 from "./TaskbarIcon.vue?vue&type=style&index=0&id=6cc71a97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc71a97",
  null
  
)

export default component.exports